"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_underground_token = (0, vue_1.resolveComponent)("underground-token");
    const _component_Tag = (0, vue_1.resolveComponent)("Tag");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.outerClass)
    }, [
        (_ctx.claimedToken !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_underground_token, {
                key: 0,
                token: _ctx.claimedToken,
                location: "tag-count"
            }, null, 8, ["token"]))
            : ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_Tag, {
                key: 1,
                tag: _ctx.tag,
                size: _ctx.size,
                type: _ctx.type
            }, null, 8, ["tag", "size", "type"])),
        (0, vue_1.createElementVNode)("span", {
            class: (0, vue_1.normalizeClass)(_ctx.innerClass)
        }, (0, vue_1.toDisplayString)(_ctx.count), 3)
    ], 2));
}
